import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import MDEditor from '@uiw/react-md-editor';
import './ArticleDetail.css';

function ArticleDetail() {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/api/articles/${id}`)
      .then(res => res.json())
      .then(data => {
        setArticle(data);
        setIsLoading(false);
      })
      .catch(err => {
        console.error('Erreur de chargement de l\'article :', err); // Fixed the apostrophe here
        setIsLoading(false);
      });
  }, [id]);

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Chargement de l'article...</p>
      </div>
    );
  }

  if (!article) {
    return (
      <div className="error-container">
        <h2>Article non trouvé</h2>
        <p>Désolé, nous n'avons pas pu charger l'article demandé.</p>
      </div>
    );
  }

  return (
    <div className="article-detail-container">
      <article className="article-content-wrapper">
        <header className="article-header">
          <div className="article-meta">
            <span className="article-date">
              Publié le {new Date(article.date).toLocaleDateString('fr-FR', { 
                year: 'numeric', 
                month: 'long', 
                day: 'numeric' 
              })}
            </span>
            {article.category && (
              <span className="article-category">{article.category}</span>
            )}
          </div>
          
          <h1 className="article-titleD">{article.title}</h1>
          <div className="title-underline"></div>
        </header>

        {article.mainImage && (
          <figure className="article-hero-image">
            <img
              src={article.mainImage}
              alt={article.title}
              className="hero-image"
              loading="lazy"
            />
            {article.imageCaption && (
              <figcaption className="image-caption">
                {article.imageCaption}
              </figcaption>
            )}
          </figure>
        )}

        <section className="article-content">
          <MDEditor.Markdown 
            source={article.content} 
            className="markdown-content"
          />
        </section>

        <footer className="article-footer">
          {(article.tags && article.tags.length > 0) && (
            <div className="tags-container">
              {article.tags.map(tag => (
                <span key={tag} className="article-tag">{tag}</span>
              ))}
            </div>
          )}
          
          <div className="author-signature">
            <span>
              Écrit par {article.author || "L'équipe Syphax Hotel"}
            </span>
          </div>
        </footer>
      </article>
    </div>
  );
}

export default ArticleDetail;